"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationDoseWithNumberDto = instanceOfVaccinationDoseWithNumberDto;
exports.VaccinationDoseWithNumberDtoFromJSON = VaccinationDoseWithNumberDtoFromJSON;
exports.VaccinationDoseWithNumberDtoFromJSONTyped = VaccinationDoseWithNumberDtoFromJSONTyped;
exports.VaccinationDoseWithNumberDtoToJSON = VaccinationDoseWithNumberDtoToJSON;
exports.VaccinationDoseWithNumberDtoToJSONTyped = VaccinationDoseWithNumberDtoToJSONTyped;
/**
 * Check if a given object implements the VaccinationDoseWithNumberDto interface.
 */
function instanceOfVaccinationDoseWithNumberDto(value) {
    if (!('doseNumber' in value) || value['doseNumber'] === undefined)
        return false;
    if (!('dateAdministered' in value) || value['dateAdministered'] === undefined)
        return false;
    return true;
}
function VaccinationDoseWithNumberDtoFromJSON(json) {
    return VaccinationDoseWithNumberDtoFromJSONTyped(json, false);
}
function VaccinationDoseWithNumberDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'doseNumber': json['doseNumber'],
        'dateAdministered': json['dateAdministered'],
    };
}
function VaccinationDoseWithNumberDtoToJSON(json) {
    return VaccinationDoseWithNumberDtoToJSONTyped(json, false);
}
function VaccinationDoseWithNumberDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'doseNumber': value['doseNumber'],
        'dateAdministered': value['dateAdministered'],
    };
}
//# sourceMappingURL=VaccinationDoseWithNumberDto.js.map